import { ShaderPreset } from './types';

const getInitialShader = (): string => {
  const scriptTag = document.getElementById('default-shader-source');
  if (scriptTag && scriptTag.textContent) {
    return scriptTag.textContent.trim();
  }
  // Fallback if the script tag is missing
  return `#version 300 es
precision mediump float;
uniform float u_time;
uniform vec2 u_resolution;
out vec4 outColor;

void main() {
    vec2 uv = gl_FragCoord.xy / u_resolution.xy;
    outColor = vec4(uv.x, uv.y, abs(sin(u_time)), 1.0);
}`;
};

export const DEFAULT_FRAGMENT_SHADER = getInitialShader();

export const PRESETS: ShaderPreset[] = [
  {
    id: 'psychedelic-blob',
    name: 'Default',
    code: DEFAULT_FRAGMENT_SHADER
  },
  {
    id: 'plasma-waves',
    name: 'Plasma Waves',
    code: `#version 300 es
precision mediump float;
uniform float u_time;
uniform vec2 u_resolution;
out vec4 outColor;

void main() {
    vec2 p = -1.0 + 2.0 * gl_FragCoord.xy / u_resolution.xy;
    float time = u_time * 1.0;
    
    float x = p.x * 2.0;
    float y = p.y * 2.0;
    
    float color = 0.0;
    color += sin(x + time);
    color += sin((y + time) / 2.0);
    color += sin((x + y + time) / 2.0);
    
    x += sin(time / 3.0) * 1.5;
    y += cos(time / 5.0) * 1.5;
    
    color += sin(sqrt(x*x + y*y + 1.0) + time);
    color /= 2.0;
    
    vec3 col = vec3(sin(color * 3.14), sin(color * 3.14 + 2.0 * 3.14 / 3.0), sin(color * 3.14 + 4.0 * 3.14 / 3.0));
    outColor = vec4(col * 0.5 + 0.5, 1.0);
}`
  },
  {
    id: 'star-field',
    name: 'Star Field',
    code: `#version 300 es
precision mediump float;
uniform float u_time;
uniform vec2 u_resolution;
out vec4 outColor;

void main() {
    vec2 uv = (gl_FragCoord.xy - 0.5 * u_resolution.xy) / u_resolution.y;
    vec3 col = vec3(0);
    
    for(float i=0.; i<1.; i+=1./8.) {
        float z = fract(i + u_time * 0.1);
        float size = mix(10., 0.1, z);
        float fade = smoothstep(0., 0.5, z) * smoothstep(1., 0.8, z);
        
        vec2 uv2 = uv * size;
        vec2 id = floor(uv2);
        vec2 gv = fract(uv2) - 0.5;
        
        float n = fract(sin(id.x * 12.34 + id.y * 56.78) * 45.67);
        float d = length(gv);
        
        if (n > 0.9) {
            col += (0.01 / d) * fade * vec3(n, n*0.8, 1.0);
        }
    }
    
    outColor = vec4(col, 1.0);
}`
  }
];

export const VERTEX_SHADER = `#version 300 es
in vec2 position;
void main() {
    gl_Position = vec4(position, 0.0, 1.0);
}`;